const SITE_URL = 'https://coursepress.lnu.se'
const PATH_PREFIX = '/courses/cloud-native-applications'

const config = {
  gatsby: {
    pathPrefix: PATH_PREFIX,
    siteUrl: SITE_URL,
    gaTrackingId: null
  },
  header: {
    logoLink: '/',
    title: 'logo-wordmark-en.png',
    courseName: 'Cloud Native Applications (2DV013)',
    links: [
      { text: 'Schema', link: 'https://cloud.timeedit.net/lnu/web/schema2/riq66Q04721Z67Qy5Q75Z2366XZ35045YY73Y0gQ20og569X42754b9yQ7ncc76QYhdmZwcZqnQo.html'},
      { text: 'Zulip', link: 'https://zulip.lnu.se/#narrow/channel/31-2dv013-Cloud-Native-Applications' },
      { text: 'GitLab', link: 'https://gitlab.lnu.se/2dv013' },
      { text: 'Zoom', link: 'https://lnu-se.zoom.us/j/61761418350' /*`${SITE_URL}${PATH_PREFIX}/zoom` */ },
      { text: 'Actionhub', link: 'https://actionhub.camp.lnu.se/' },
      { text: 'LNU Play 2026', link: 'https://play.lnu.se/channel/2dv013-ht26+Cloud+Native+Applications/852045'},
      { text: 'LNU Play 2025', link: 'https://play.lnu.se/channel/2dv013-ht25%2BCloud%2BNative%2BApplications/790470'},
      { text: 'YouTube', link: 'https://www.youtube.com/cslnu' },
    ]
  },
  sidebar: {
    frontline: false,
    ignoreIndex: true,
    startCollapsed: true
  },
  siteMetadata: {
    title: 'Linnaeus University',
    courseCode: '2DV013',
    language: "en",
    description: '',
    ogImage: null
  }
}

module.exports = config

